export const MIN_FAN_BID_JPY = 500;
export const FAN_BID_STEP_JPY = 100;
export const MAX_FAN_BID_JPY = 100_000;

export function normalizeFanBid(amountJpy: number): number {
  const safeAmount = Number.isFinite(amountJpy) ? amountJpy : MIN_FAN_BID_JPY;
  const stepped = Math.ceil(safeAmount / FAN_BID_STEP_JPY) * FAN_BID_STEP_JPY;
  return Math.min(MAX_FAN_BID_JPY, Math.max(MIN_FAN_BID_JPY, stepped));
}

export function bidToTakeLead(currentJpy: number, leaderJpy: number): number {
  if (currentJpy >= leaderJpy) return MIN_FAN_BID_JPY;
  return Math.max(MIN_FAN_BID_JPY, Math.ceil((leaderJpy - currentJpy + 1) / FAN_BID_STEP_JPY) * FAN_BID_STEP_JPY);
}

export function projectedRankAfterBid(
  campaignId: string,
  currentJpy: number,
  bidJpy: number,
  entries: ReadonlyArray<{ campaignId: string; amountJpy: number }>,
): number {
  const safeBidJpy = Number.isFinite(bidJpy) ? Math.max(0, bidJpy) : 0;
  const projectedJpy = currentJpy + Math.ceil(safeBidJpy / FAN_BID_STEP_JPY) * FAN_BID_STEP_JPY;
  return 1 + entries.filter((entry) => entry.campaignId !== campaignId && entry.amountJpy >= projectedJpy).length;
}
